//基本路由 
export default {
     'dispute': resolve => require(['../page/Dispute.vue'], resolve),
     'feedback': resolve => require(['../page/Feedback.vue'], resolve),
     'index': resolve => require(['../page/Index.vue'], resolve),
     'login': resolve => require(['../page/Login.vue'], resolve),
     'register': resolve => require(['../page/Register.vue'], resolve),
     'curriculum/deatils': resolve => require(['../page/curriculum/Deatils.vue'], resolve),
     'curriculum/pay': resolve => require(['../page/curriculum/Pay.vue'], resolve),
     'curriculum/seach': resolve => require(['../page/curriculum/Seach.vue'], resolve),
     'curriculum/signup': resolve => require(['../page/curriculum/Signup.vue'], resolve),
     'open/index': resolve => require(['../page/open/Index.vue'], resolve),
     'personal/culum': resolve => require(['../page/personal/Culum.vue'], resolve),
     'personal/cuperlist': resolve => require(['../page/personal/Cuperlist.vue'], resolve),
     'personal/date': resolve => require(['../page/personal/Date.vue'], resolve),
     'personal/index': resolve => require(['../page/personal/Index.vue'], resolve),
     'personal/playvideo': resolve => require(['../page/personal/Playvideo.vue'], resolve),
     'personal/refund': resolve => require(['../page/personal/Refund.vue'], resolve),
     'practice/analysis': resolve => require(['../page/practice/Analysis.vue'], resolve),
     'practice/answercard': resolve => require(['../page/practice/Answercard.vue'], resolve),
     'practice/corrections': resolve => require(['../page/practice/Corrections.vue'], resolve),
     'practice/index': resolve => require(['../page/practice/Index.vue'], resolve),
     'practice/paper': resolve => require(['../page/practice/Paper.vue'], resolve),
     'practice/subject': resolve => require(['../page/practice/Subject.vue'], resolve),
     'practice/test': resolve => require(['../page/practice/Test.vue'], resolve),
     'line/linelist': resolve => require(['../page/line/linelist.vue'], resolve),
     'line/linedetail': resolve => require(['../page/line/linedetail.vue'], resolve),
     'realtime/realtime': resolve => require(['../page/realtime/realtime.vue'], resolve),
     'realtime/realtimeDetail': resolve => require(['../page/realtime/realtimeDetail.vue'], resolve),
     'webshopping/home': resolve => require(['../page/webshopping/home.vue'], resolve),
     'webshopping/shoppingSearch': resolve => require(['../page/webshopping/shopping_search.vue'], resolve),
     "webshopping/shoppingDetails": resolve => require(['../page/webshopping/shopping_details.vue'], resolve),
     'webshopping/shopping_cart': resolve => require(['../page/webshopping/shopping_cart.vue'], resolve),
     'webshopping/shopping_price': resolve => require(['../page/webshopping/shopping_price.vue'], resolve),
     'webshopping/shopping_order': resolve => require(['../page/webshopping/order.vue'], resolve),
     'webshopping/order_details': resolve => require(['../page/webshopping/order_details.vue'], resolve),
     'webim/webim': resolve => require(['../page/webshopping/imword.vue'], resolve),
     'littlevideo/little_playvideo': resolve => require(['../page/webshopping/little_playvideo.vue'], resolve),
       //首页
      '/': resolve => require(['../page/Index.vue'], resolve)
}


// WEBPACK FOOTER //
// ./src/routes/base.js